import OnSurveysLoaded from "../../../../contents/docs/surveys/_snippets/onsurveysloaded-callout.md";
import * as React from 'react';
export default {
  OnSurveysLoaded,
  React
};